import Box, { BoxProps } from "@mui/material/Box"
import React from "react"

const FakeMaterialBox = React.forwardRef<HTMLDivElement, BoxProps>(
    (props, ref) => <Box {...props} ref={ref} />,
)

export default FakeMaterialBox
